export const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Local YYYY-MM-DD (toISOString alone would shift to UTC)
export const toDateStr = (d = new Date()) =>
    new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0];

// Mon-Sun of the week containing `now`, e.g. { Monday: "2026-11-02", ... }
export const getWeekDates = (now = new Date()) => {
    const daysSinceMonday = (now.getDay() + 6) % 7;
    return Object.fromEntries(WEEK_DAYS.map((day, i) => [
        day,
        toDateStr(new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysSinceMonday + i)),
    ]));
};

// ISO date strings compare correctly as plain strings
export const dayState = (date, today = toDateStr()) =>
    date === today ? "today" : date > today ? "future" : "past";

// "2026-11-03" -> "03 Nov"
export const shortDate = (date) => `${date.slice(8)} ${MONTHS[Number(date.slice(5, 7)) - 1]}`;
